import { FC } from 'react'
import { Input as AntdInput, type InputProps as AntdInputProps } from 'antd'
import cn from 'classnames'
import classes from './index.module.css'

interface InputProps extends AntdInputProps {
  size?: 'small' | 'middle'
}

const Input: FC<InputProps> = ({ className, size, ...props }) => {
  return (
    <AntdInput
      {...props}
      className={cn(className, classes.input, {
        [classes.inputSmall]: size === 'small',
      })}
    />
  )
}

export default Input
